var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__envelope--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 4H3a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2zm-1.814 2L12 10.746 4.815 6zM3 18V7.2l8.45 5.582a1 1 0 001.1 0L21 7.2V18z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }